export default __webpack_public_path__ + "static/media/logo.414a5c09.svg";